<template>
  <div class="content">
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 d-inline-block mb-0">
            {{ $t("menu.mlhg") }}
          </h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
        <div class="col-lg-6 col-5 text-right">
          <base-button
            size="md"
            type="neutral"
            @click="handleShowModal()"
            v-if="isDtacAdmin || isCorporateAdmin || isCorporateSuperAdmin"
            >{{ $t("number.add") }}</base-button
          >
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div>
        <card
          class="no-border-card"
          body-classes="px-0 pb-1"
          footer-classes="pb-2"
        >
          <template slot="header">
            <h3 class="mb-0" v-if="$route.query.corporate_name == ''">
              {{ $route.query.mlhg_name }} > {{ $t("menu.number") }}
            </h3>
            <h3 class="mb-0" v-else>
              {{ $route.query.corporate_name }} > {{ $route.query.mlhg_name }} > {{ $t("menu.number") }}
            </h3>
          </template>
          <div>
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <el-select
                class="select-primary pagination-select"
                v-model="pagination.perPage"
                placeholder="Per page"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>

              <div>
                <base-input
                  v-model="searchQuery"
                  prepend-icon="fas fa-search"
                  :placeholder="$t('search')"
                >
                </base-input>
              </div>
            </div>
            <el-table
              :data="queriedData"
              row-key="id"
              header-row-class-name="thead-light"
              @sort-change="sortChange"
              @selection-change="selectionChange"
            >
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                v-bind="column"
              >
              </el-table-column>

              <el-table-column
                max-width="200px"
                align="left"
                :label="$t('actions')"
                v-if="(isDtacAdmin || isCorporateSuperAdmin)  || (  isCorporateAdmin   && $route.query.pilot_type == 'dummy' )"
              >
                <div slot-scope="{ $index, row }" class="d-flex">
                  <base-button
                    @click.native="handleDelete($index, row)"
                    class="remove btn-link"
                    type="danger"
                    size="sm"
                    icon
                  >
                    <i class="text-dtac-bt fa fa-trash"></i>
                  </base-button>
                </div>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
			v-if="queriedData.length != 0"
          >
            <div class="">
              <p class="card-category">
                {{ $t("data") }} {{ from + 1 }} {{ $t("to") }} {{ to }}
                {{ $t("of") }}
                {{ total }}
                <span v-if="selectedRows.length">
                  - &nbsp; &nbsp; {{ selectedRows.length }}
                  {{ $t("row_select") }}
                </span>
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            >
            </base-pagination>
          </div>
        </card>
      </div>
    </div>

    <modal :show.sync="showAddModal" modal-classes="modal-secondary">
      <form class="new-event--form" @submit.prevent="saveEvent">
        <base-input :label="$t('number.add')" readonly>
          <el-select v-model="number" filterable :placeholder="$t('number.add')" readonly>
            <el-option
              v-for="option in getNumberByCorporateID"
              :key="option.Number"
              :label="option.Number"
              :value="option.ID"
            >
            </el-option>
          </el-select>
        </base-input>

        <input type="hidden" class="new-event--start" />
        <input type="hidden" class="new-event--end" />
      </form>

      <template slot="footer">
        <button type="button"
          v-if="number != ''"
          class="btn btn-sm btn-primary disabled"
          @click="handleAdd()"
        >
          {{ $t("add") }}
        </button>

        <button
          type="button"
          class="btn btn-sm btn-link ml-auto"
          @click="showAddModal = false"
        >
          {{ $t("close") }}
        </button>
      </template>
    </modal>
  </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "./PagingMLHGNumber/clientPaginationMixin";
import swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";

export default {
  mixins: [clientPaginationMixin],
  components: {
    BasePagination,
    RouteBreadCrumb,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  computed: {
    ...mapGetters({
      isCorporateAdmin: "Auth/isCorporateAdmin",
      isCorporateSuperAdmin: "Auth/isCorporateSuperAdmin",
      isDtacAdmin: "Auth/isDtacAdmin",
      isReadOnly: "Auth/isReadOnly",
      tableData: "MlhgNumber/getData",
      getNumberByCorporateID: "MlhgNumber/getNumberByCorporateID",
      getMlhgMember: "MlhgNumber/getMlhgMember"
    }),
    tableColumns: function() {
      return [
        {
          prop: "Number",
          label: this.$t("menu.number"),
          minWidth: 160,
          sortable: false
        }
      ];
    }
  },
  data() {
    return {
      showAddModal: false,
      number: {},
      propsToSearch: ["Number"],
      selectedRows: [],
      selects: ""
    };
  },
  mounted() {
    this.listData({
      mlhgID: this.$route.query.mlhg_id
    });

    this.listCorporateNumber({
      enterpriseID: this.$route.query.corporate_id
    });
  },
  methods: {
    ...mapActions({
      createData: "MlhgNumber/createData",
      deleteData: "MlhgNumber/deleteData",
      listData: "MlhgNumber/listData",
      listCorporateNumber: "MlhgNumber/listCorporateNumber"
    }),
    reloadMember() {
      this.listData({
        mlhgID: this.$route.query.mlhg_id
      });

      this.listCorporateNumber({
        enterpriseID: this.$route.query.corporate_id
      });
    },
    handleShowModal(){

      this.showAddModal = true;
      this.number = this.getNumberByCorporateID[0].ID
    },
    handleAdd(index, row) {
      this.showAddModal = false;

      let addNumber = this.getNumberByCorporateID.filter(item => {
        return item.ID == this.number;
      });


      this.createData({
        mlhgID: this.$route.query.mlhg_id,
        data: JSON.stringify({
          ID: [addNumber[0].ID],
          Number: [addNumber[0].Number]
        })
      })
        .then(resp => {
          this.reloadMember();
          swal.fire({
            title: this.$t("create_success"),
            text: ``,
            icon: "success",
            confirmButtonClass: "btn btn-success btn-fill",
            buttonsStyling: false
          });
        })
        .catch(err => {
          swal.fire({
            title: this.$t(err.response.data.Msg),
            text: this.getErrorText(err.response.data),
            icon: "error",
            confirmButtonClass: "btn btn-danger btn-fill",
            buttonsStyling: false
          });
        });
    },
    handleDelete(index, row) {
      swal
        .fire({
          title: this.$t("delete_confirm"),
          text: this.$t("delete_confirm_question") + row.Number,
          icon: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: this.$t("confirm"),
          cancelButtonText: this.$t("cancel"),
          buttonsStyling: false
        })
        .then(result => {
          if (result.value) {
            this.deleteData({
              mlhgID: this.$route.query.mlhg_id,
              data: JSON.stringify({
                ID: [row.ID],
                Number: [row.Number]
              })
            })
              .then(resp => {
                this.reloadMember();
                swal.fire({
                  title: this.$t("delete_success"),
                  text: ``,
                  icon: "success",
                  confirmButtonClass: "btn btn-success btn-fill",
                  buttonsStyling: false
                });
              })
              .catch(err => {
                swal.fire({
                  title: this.$t(err.response.data.Msg),
                  text: this.getErrorText(err.response.data),
                  icon: "error",
                  confirmButtonClass: "btn btn-danger btn-fill",
                  buttonsStyling: false
                });
              });
          }
        });
    },
    selectionChange(selectedRows) {
      this.selectedRows = selectedRows;
    }
  }
};
</script>
<style>
.no-border-card .card-footer {
  border-top: 0;
}
</style>
